import { scaleTime, scaleLinear } from 'd3-scale';
import { extent } from 'd3-array';
import { RootState } from 'reducers';
import { Props } from './index';
import { MountainChartFragment_data } from './__generated__/MountainChartFragment';

type Point = MountainChartFragment_data & {
  time: Date;
};

const values = {
  x: (d: Point) => d.time,
  y: (d: Point) => d.close,
};

export const selector = (state: RootState, props: Props) => {
  const { data } = props;

  const curve = data.map((point) => ({ ...point, time: new Date(point.time) } as Point));

  const width = props.width || 910;
  const height = props.height || 200;
  const plotGeo = { width, height };

  const [xMin, xMax] = extent<Point, Date>(curve, values.x);

  const xScale = scaleTime().rangeRound([0, width]).domain([xMin!, xMax!]);

  const [yMin, yMax] = extent<Point, number>(curve, values.y);

  const yScale = scaleLinear().rangeRound([height, 0]).domain([yMin!, yMax!]);

  return {
    ...props,
    width,
    height,
    plotGeo,
    scales: { x: xScale, y: yScale },
    values,
    data: curve,
    areaBase: yMin,
  };
};
